import { createContext, useContext } from "react";

const VersionContext = createContext({
  versionId: 0,
  setVersionId: () => null,
  modificationId: null,
  setModificationId: () => null,
});

export const VersionProvider = VersionContext.Provider;

export const useVersionContext = () => useContext(VersionContext);
